import { useTranslation } from 'react-i18next';

const UploadedMomentsEmptyState = () => {
  const { t } = useTranslation('organizations');

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex-1 flex flex-col items-center justify-center">
        <div>
          <img src="/img/events/create/moments.png" className="mx-auto" />
        </div>
        <div className="text-[14px] font-bold">
          <b>{t('moments.noMomentsYet')}</b>
        </div>
        <div className="mt-2 text-sm text-gray-600 font-normal">
          {t('moments.uploadedFilesAppear')}
        </div>
      </div>
    </div>
  );
};

export default UploadedMomentsEmptyState;
